import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'sms-opt-in-failed:popup-title': {
    id: 'sms-opt-in-failed:popup-title',
    defaultMessage: 'That didn’t work...',
    description: 'Sms opt in failed attempt: popup title',
  },
  'sms-opt-in-failed:popup-description': {
    id: 'sms-opt-in-failed:popup-description',
    defaultMessage:
      'We couldn’t send your login {authMethod} because text messages (SMS) are blocked for your number. To enable messaging text {smsOptInKeyword} to {smsOptInPhoneNumber}, or contact support for help.',
    description: 'Sms opt in failed attempt: popup text',
  },
  'sms-opt-in-failed:popup-confirm-button-text': {
    id: 'sms-opt-in-failed:popup-confirm-button-text',
    defaultMessage: 'Try again',
    description: 'Sms opt in failed attempt: popup confirm button text',
  },
  'sms-opt-in-failed:popup-support-button-text': {
    id: 'sms-opt-in-failed:popup-support-button-text',
    defaultMessage: 'Contact Support',
    description: 'Sms opt in failed attempt: popup support button text',
  },
});
